import React from 'react'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import copy from 'copy-to-clipboard'

export default function CopyToClipboard({ text, children }) {
  function handleCopyFinish(e) {
    e.stopPropagation()
    copy(text)
    toast('Copy to clipboard.', { type: 'default' })
  }

  if (!text) {
    return null
  }

  return (
    <div className="field has-addons">
      <div className="control is-hidden-mobile">
        <input className="input" type="text" value={text} disabled />
      </div>
      <div className="control">
        <button className="button" onClick={handleCopyFinish}>
          <span className="icon">
            <i className="far fa-clipboard" />
          </span>
        </button>
        {children}
      </div>
    </div>
  )
}

CopyToClipboard.propTypes = {
  text: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/views/widgets/CopyToClipboard.js